var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.34,
    height: 102.34,
    viewBox: "0 0 102.34 102.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3, .cls-5 {\n        fill: #cacaca;\n      }\n\n      .cls-1 {\n        stroke: #a8a8a8;\n      }\n\n      .cls-1, .cls-2, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-4 {\n        fill: #858585;\n      }\n\n      .cls-2 {\n        stroke: #cacaca;\n        stroke-width: 0.25px;\n      }\n\n      .cls-5 {\n        stroke: #858585;\n        stroke-width: 0.745px;\n      }\n\n      .cls-6 {\n        opacity: 0.31;\n      }\n\n      .cls-7 {\n        fill: #6c6c6c;\n      }\n\n      .cls-8 {\n        opacity: 0.5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-1",
    cx: 50.67,
    cy: 50.67,
    r: 50.67,
    transform: "translate(0.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    className: "cls-2",
    cx: 27.36,
    cy: 27.36,
    r: 27.36,
    transform: "translate(22.41 23.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    className: "cls-3",
    d: "M25.33,50a20.48,20.48,0,0,0-10.2.09.61.61,0,0,0,0,1.17,20.48,20.48,0,0,0,10.2.09.7.7,0,0,0,0-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    className: "cls-3",
    d: "M49.26,26.17c1.12-1.58.52-4.27.3-6.05,0-.36-.61-.52-.69-.1-.31,1.83-1.07,4.48,0,6.15a.23.23,0,0,0,.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    className: "cls-3",
    d: "M74.73,51.4a7.36,7.36,0,0,0,3.4.4,8.51,8.51,0,0,0,3.35-.57c.47-.21.24-.84-.13-1a8.54,8.54,0,0,0-3.48-.43,7.1,7.1,0,0,0-3.14.48.65.65,0,0,0,0,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    className: "cls-3",
    d: "M49.4,75.66c-.89,1.44-.65,3.27-.67,4.91a32,32,0,0,0,.4,5.61.56.56,0,0,0,1.08,0,31.07,31.07,0,0,0,.53-5.61c0-1.65.3-3.44-.55-4.91a.46.46,0,0,0-.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    className: "cls-4",
    d: "M42.83,5.07l-.95.71c-.8.6.59.72,1,.59,3-.91,14.08-5.57,13.25,1-.09.75,2.08.34,2.17-.31,1-8.13-12.67-2.51-15.67-1.57l1,.59.95-.71c.94-.71-1.22-.62-1.71-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    className: "cls-4",
    d: "M45.52,21.32a44.131,44.131,0,0,1,5.93-1.93c1.82-.45,6.39-2.1,5.07,1.43-.44,1.17,1.73,1.16,2.08.25,2.91-7.76-11.23-2.17-14.05-1-1.38.55-.16,1.74,1,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    className: "cls-4",
    d: "M44.93,83.23l-2.24.85.9,1,5.1-2c1-.4,8.17-3.7,7.78-.14-.1,1,2.1.57,2.18-.24.78-7.15-13.9.58-16,1.4-1.4.56-.13,1.4.9,1l2.23-.85c1.41-.53.14-1.41-.89-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    className: "cls-4",
    d: "M46.88,85.73l-1.36.88c-1,.64.1,1.38.89,1.13a73.372,73.372,0,0,0,7-2.69l-1.5-.67a14.73,14.73,0,0,0-2,3.83c-.4,1.15-1,2.86-.73,4.09.5,2.26,3.26,1,4.55.24s3.85-2.88,1.6-4.1c-1.82-1-4.44.81-5.59,2.1-.89,1,1.2,1.23,1.8.56a3.23,3.23,0,0,1,1.23-1c.95-.29.59.83.11,1.25-1.25,1.08-1.58.22-1.37-1A13.7,13.7,0,0,1,54,84.57c.61-.85-1.11-.85-1.49-.68a65.268,65.268,0,0,1-6.44,2.48l.89,1.13,1.35-.89c1.23-.81-.58-1.43-1.41-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    className: "cls-4",
    d: "M46.42,96.92l-.62.39c-.94.59.94.45,1.22.35l5.87-2.08c1.75-.61,6.26-2.94,5.84.72-.07.61,2.08.2,2.15-.36.28-2.46-.85-3.41-3.19-2.86-3.87.91-7.7,2.68-11.44,4l1.23.35L48.1,97c.93-.58-1.24-.4-1.68-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    className: "cls-4",
    d: "M45.25,7.76l-.08,9.56c0,1.07,2.18.7,2.19-.2l.08-9.56c0-1.07-2.18-.7-2.19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    className: "cls-4",
    d: "M50.43,11.64a5.21,5.21,0,0,0,3.85-2.18c.7-1.15.81-3.32-1-3.41-3.73-.2-5.83,5.72-4,8.42,1.55,2.24,6.51,2.06,7.11-1,.34-1.72-1.2-2.11-2.56-1.94a7.37,7.37,0,0,0-4.67,2.32c-.42.47,1.62.21,2-.18,3.31-3.67,4,1.75,1.59,1.29-1.39-.27-2-2.35-2-3.51,0-.32,1.06-4.54,1.61-4.24a3.91,3.91,0,0,1,.2,1.16,2.59,2.59,0,0,1-1.78,2.5c-.86.13-1.94,1-.41.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    className: "cls-4",
    d: "M96.19,42.73c1-2.36-1.56-3.43-3.52-3.32-4.17.23-8.54,1.78-12.61,2.68-1.3.28-1.06,1.18.24.89l7-1.55c1.57-.34,8.31-2.17,6.74,1.63-.23.54,1.89.31,2.16-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    className: "cls-4",
    d: "M90.59,42.72c-2,.35-4,.63-6,1.07a3.52,3.52,0,0,0-2,.9c-.83,1-.43,3-.43,4.15v6.31c0,1,2.18.5,2.18-.25V47.24c0-1.69.51-2.27,2.16-2.56L90.31,44c1-.19,1.77-1.54.28-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    className: "cls-4",
    d: "M81.37,58.42l7.3-1.94a19.2,19.2,0,0,1,3.12-.84c2.59-.14,3.65,1.11,2.67,3-.28.56,1.84.36,2.17-.29,1.12-2.22-.52-4.12-2.81-4.13a22.619,22.619,0,0,0-5.42,1.22l-7.29,1.94c-1.29.35-1,1.34.26,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    className: "cls-4",
    d: "M3.1,45.61l7.05-2.7c1.13-.43,2.61-1.61,3.51-.31a4,4,0,0,1,.25,2.72c0,.21,2.1,0,2.17-.58.28-2.42-.56-4.11-3.1-3.55-3.58.78-7.19,2.69-10.61,4-1.44.55-.07.73.73.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    className: "cls-4",
    d: "M7,61.88l5.72-2.13c.86-.32,2.13-1.06,3-.4s.94,1.94,1.08,2.85c.09.59,2.28.1,2.17-.58-.32-2.16-1.2-3.95-3.64-3.69a14.49,14.49,0,0,0-3.47,1.12L6.21,61.18c-1.44.54-.11,1,.8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    className: "cls-4",
    d: "M6.28,51.12c.11,3.22,1.35,8.56,5.74,6.67,3.71-1.6,4-6.67,2.17-9.72-.47-.79-2.55,0-2,.94a6.2,6.2,0,0,1,.08,6.42c-2.47,3.92-3.75-3.14-3.8-4.49,0-1.1-2.23-.74-2.2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    className: "cls-4",
    d: "M8.54,55.09A62,62,0,0,1,16,51.69c1.42-.54.14-1.33-.87-.95a68.3,68.3,0,0,0-8,3.66c-.39.22-.53.59-.18.89s1.19,0,1.55-.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-5",
    cx: 40.548,
    cy: 3.02,
    rx: 40.548,
    ry: 3.02,
    transform: "matrix(0.644, -0.765, 0.765, 0.644, 22.622, 79.821)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    className: "cls-4",
    d: "M77.61,20.47q-4.27,7.84-9.17,15.3c-.62.95,2.22.58,2.66-.09Q76.11,28,80.48,20c.32-.59-2.43-.37-2.87.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    className: "cls-4",
    d: "M27.57,82.52a51,51,0,0,0,12-10.64c.82-1-2.09-.83-2.71-.08a47.14,47.14,0,0,1-11.07,9.82c-1.64,1,.86,1.51,1.81.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    className: "cls-4",
    d: "M70.27,33.22A86.6,86.6,0,0,0,79,20.27c.2-.35-.54-.35-.69-.08A85.7,85.7,0,0,1,69.67,33c-.29.35.4.45.6.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    className: "cls-4",
    d: "M70.28,32.15l-1,1.74c0,.08.61,0,.71-.13L71,32c.05-.08-.61-.05-.71.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    className: "cls-4",
    d: "M70.16,32.12l-.94,1.46c-.26.39.42.52.61.23l.94-1.47c.25-.39-.42-.52-.61-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    className: "cls-4",
    d: "M70.43,32.19c-.42.49-.81,1-1.18,1.52-.19.28.54.24.68,0A16.55,16.55,0,0,1,71,32.33c.28-.33-.42-.33-.59-.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    className: "cls-4",
    d: "M70.36,32.08,69.17,33.7c-.19.25.53.19.67,0L71,32.09c.19-.26-.53-.2-.67,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    className: "cls-4",
    d: "M70.49,32A18.911,18.911,0,0,0,69,34.09c-.05.07.6,0,.71-.13a18.119,18.119,0,0,1,1.46-2.12c.07-.1-.27-.06-.29-.06a.84.84,0,0,0-.43.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    className: "cls-4",
    d: "M70.63,31.74l-1.72,2.77c-.16.25.56.16.67,0l1.71-2.76c.16-.26-.55-.17-.66,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    className: "cls-4",
    d: "M25.3,82.5c1.37-.06,2.25-.85,3.31-1.67a61.83,61.83,0,0,0,5.54-4.94c.29-.3-.37-.25-.51-.16a15.49,15.49,0,0,0-2.39,2c-.31.32.42.22.58.11A32.28,32.28,0,0,0,36.21,74c.31-.31-.37-.22-.51-.15A10.55,10.55,0,0,0,32.8,76c-.31.31.37.23.51.15A12.291,12.291,0,0,0,35.09,75c.32-.25-.41-.23-.58-.11a24.37,24.37,0,0,0-2.46,2.08c-.3.29.41.27.58.11A22.178,22.178,0,0,1,35.09,75l-.58-.11a7.53,7.53,0,0,1-1.65,1.07l.51.15a10.49,10.49,0,0,1,2.78-2l-.51-.15a32.271,32.271,0,0,1-4.39,3.79l.58.11a14.41,14.41,0,0,1,2.25-1.87l-.51-.15c-1,1-2.12,2.08-3.24,3S27.05,82,25.59,82.1C25.33,82.1,24.82,82.52,25.3,82.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    className: "cls-7",
    d: "M50.05,75.67a5,5,0,0,1,.87,2.68c0,.25.73.1.72-.2a5.18,5.18,0,0,0-.92-2.77c-.15-.22-.85,0-.67.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    className: "cls-7",
    d: "M74,51.53a3.94,3.94,0,0,0,2.79.67l-.32-.2v.05c-.18.2.53.14.67,0v-.06c.15-.17-.21-.17-.27-.16a3.21,3.21,0,0,1-2.23-.6c-.19-.13-.83.16-.68.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    className: "cls-7",
    d: "M49.88,26.27a5.71,5.71,0,0,0,.67-2.18l-.58.26a6.36,6.36,0,0,0,1.51.1c.38,0,.58-.49.08-.46a5,5,0,0,1-1.16-.08c-.17,0-.56,0-.58.26a5.32,5.32,0,0,1-.63,2c-.18.33.55.29.69.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2073",
    "data-name": "Group 2073",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    className: "cls-7",
    d: "M25.57,51.32a7.18,7.18,0,0,1-2.55.45c-.16,0-.51.08-.5.29a11.92,11.92,0,0,0,.25,2.31c.05.24.78.06.73-.19a12,12,0,0,1-.26-2.31l-.5.29a8.74,8.74,0,0,0,3.11-.57c.47-.18,0-.39-.28-.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    className: "cls-4",
    d: "M5.64,51.75c0,3,1.6,7.38,5.06,7.8,3,.37,5.38-3.2,4.4-5.87a.59.59,0,0,0-1.1-.13c-1.16,1.53-1.67,5.36-4.31,3a16.92,16.92,0,0,1-3.36-5,.39.39,0,0,0-.73.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    className: "cls-4",
    d: "M45.74,89.12c1.7-.06,3.28-1,4.88-1.48l-1.18-1.19c-.63,2.06-1.51,5.09,0,7C51,95.5,53.37,94,54.5,92.31c.71-1-1-2.37-1.76-1.36-.28.35-.78,1.08-1.31,1-.75-.1-.66-.86-.66-1.36A14.41,14.41,0,0,1,51.3,87a1,1,0,0,0-1.19-1.18c-1.58.55-3.42.76-4.8,1.74a.87.87,0,0,0,.43,1.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    className: "cls-4",
    d: "M90.25,44.43l.28.08c.47.15.8-.6.34-.81-1.19-.53-2.43-.11-3.7.07s-2.28.31-3,1.3a5.2,5.2,0,0,0-.67,3c-.11,1.94-.26,3.89-.26,5.83a1.27,1.27,0,0,0,2.53,0c.08-1.09.1-2.18.13-3.28A14.32,14.32,0,0,1,86,47c.69-2,3.67-1.2,5-2.59L90.22,44l-.08.26a.17.17,0,0,0,.11.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    className: "cls-4",
    d: "M46.9,11.2a3,3,0,0,0-1,2.31c-.19,1.46-.2,3-.45,4.42-.31,1.82,2.5,2,2.4.32-.08-1.4.08-2.81,0-4.22,0-1,.07-2.1-.72-2.8a.24.24,0,0,0-.29,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    className: "cls-4",
    d: "M49.65,13.5c.43,1.53,1,2.74,2.56,3.33a4.73,4.73,0,0,0,4.49-.77c1.12-.86,1.93-2.5.7-3.66s-4-.81-5.17.08c-.35.27-.5.91,0,1.14a6.06,6.06,0,0,0,2.11.43c.13,0,1.23,0,1.28.14.28.65-.95,1-1.32,1.13a4.21,4.21,0,0,1-4.42-1.91.123.123,0,0,0-.23.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    className: "cls-4",
    d: "M52.25,12.41a4,4,0,0,0,2.82-1.16,2.42,2.42,0,0,0,.4-2.45c-.8-2-5-1.81-5.52.31a.78.78,0,0,0,.74,1c1,.06,2.11-1,3.09-.49,1.14.53-1.36,1.64-1.67,1.75-.54.19-.51,1.16.14,1.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    className: "cls-4",
    d: "M48.18,61.16a2.52,2.52,0,1,0-2.52-2.51,2.55,2.55,0,0,0,2.52,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    className: "cls-4",
    d: "M42.81,57.82A3.78,3.78,0,1,0,39,54a3.82,3.82,0,0,0,3.78,3.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    className: "cls-4",
    d: "M45.53,53.09a3.16,3.16,0,0,1,.18,1.36,14,14,0,0,0-.27,1.41.84.84,0,0,0,1.42.59,4.4,4.4,0,0,0,.69-3.92c-.31-1.21-2.38-.74-2,.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    className: "cls-4",
    d: "M46.65,57.83a3.88,3.88,0,0,1,1.82.14,2.43,2.43,0,0,1,.54.31,1.69,1.69,0,0,0,1.45.33,1.22,1.22,0,0,0,.87-1.15c0-1.2-1.27-1.8-2.28-2a4,4,0,0,0-2.93.4c-.87.48-.55,2.12.53,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    className: "cls-4",
    d: "M26.79,82c3.74-3.07,7-6.69,10.59-10S44.74,65.59,48,62a.841.841,0,0,0-1.19-1.19c-3.79,3-7.18,6.56-10.69,9.87S28.73,77,25.4,80.56A1,1,0,0,0,26.79,82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    className: "cls-4",
    d: "M75.71,22.64C65.88,31.21,58.47,43.45,50.6,53.77c-1.47,1.93,1.85,3.9,3.3,1.92,7.56-10.4,17-20.86,22.37-32.61a.36.36,0,0,0-.56-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    className: "cls-7",
    d: "M69.81,35c-4.51,4.14-8.3,9.3-12.23,14-1.75,2.11-3.47,5.16-5.65,6.81-1.49,1.13-3.3.39-4.63,1.41-2.41,1.85.55,5.26,2.37,2.45a.73.73,0,0,0,0-.74l-.47-.69a.73.73,0,0,0-.64-.36l-.8.07a.76.76,0,0,0-.64,1.12c1,1.74,3,1.27,3-.79a.72.72,0,0,0-.7-.71h-.28a.72.72,0,0,0-.7.7v.36a.7.7,0,0,0,.51.68c2.87.56,5.71-4.68,7.14-6.55,4.7-6.15,9.62-12.14,14.81-17.89l-.9-.82q-4.65,5.19-9.2,10.45l1,1c2.87-3.45,5.65-7,8.24-10.63.5-.71-.65-1.35-1.16-.68-2.63,3.49-5.3,6.93-8.11,10.27-.6.72.41,1.75,1,1q4.56-5.28,9-10.64c.48-.58-.33-1.42-.85-.85-3.59,4-7.15,8.09-10.55,12.29-1.11,1.37-10.49,13-11,12l-.65,1.12a17.46,17.46,0,0,0,4.45-1.72c2.25-1.5,4.08-4.81,5.8-6.9,4.14-5,8.79-10,12.24-15.53a.28.28,0,0,0-.44-.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    className: "cls-7",
    d: "M47.39,58.46a.62.62,0,1,0-.541-.615.62.62,0,0,0,.541.615Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    className: "cls-7",
    d: "M47.13,58.54c.52-.2.92-.58,1.47-.74s1.16,0,1.56-.27a.4.4,0,0,0,.08-.63c-.41-.5-1.38-.28-1.92-.11a2.66,2.66,0,0,0-1.66,1.14c-.13.29.09.74.47.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    className: "cls-7",
    d: "M47,58.37a4.23,4.23,0,0,1,2-.79,17.3,17.3,0,0,0,1.85.23.27.27,0,0,0,.23-.4c-.36-.77-1.47-.81-2.2-.71A2.72,2.72,0,0,0,46.72,58c-.12.2.12.47.32.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    className: "cls-7",
    d: "M49.06,57.56a2.64,2.64,0,0,1,1.15.13,5.479,5.479,0,0,0,1,.31.26.26,0,0,0,.25-.33c-.33-1-1.64-1-2.45-.68-.27.11-.27.61.08.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    className: "cls-7",
    d: "M50.68,57.34a52.71,52.71,0,0,0,5.57-5.71,44.709,44.709,0,0,0,4.63-5.57c.26-.4-.31-.81-.63-.5-1.79,1.75-3.31,3.82-5,5.7s-3.52,3.65-5.06,5.63a.32.32,0,0,0,.45.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    className: "cls-7",
    d: "M51.2,57.49c6.32-6.44,11.86-13.81,17.42-20.89.49-.62-.36-1.5-.87-.88-5.72,7-11.52,13.85-17.22,20.82-.58.71.43,1.74,1,1,5.73-7,11.36-14,17.07-21l-.87-.88c-5.62,7.16-11.72,14-17.12,21.33-.25.34.29.73.57.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2091",
    "data-name": "Group 2091",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    className: "cls-7",
    d: "M49.22,56.84c-.4-.55-1.19-.38-1.7-.07a2.14,2.14,0,0,0-1,1.62c-.06.55.9.69,1,.13a1.18,1.18,0,0,1,.6-.92c.32-.19.71-.13,1-.31a.32.32,0,0,0,.12-.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2092",
    "data-name": "Group 2092",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    className: "cls-7",
    d: "M49.8,57.6A1.69,1.69,0,0,0,47,57a1.88,1.88,0,0,0-.48,1.63c.1.55.49,1.23,1.13,1.1a.34.34,0,0,0,.25-.33c0-.56-.61-1-.19-1.61s1.23-.27,1.61.11a.3.3,0,0,0,.49-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2093",
    "data-name": "Group 2093",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    className: "cls-7",
    d: "M49.36,56.79a1.37,1.37,0,0,0-1.78.69c-.24.54-.09,1.72.72,1.65a.3.3,0,0,0,.3-.3c0-.31-.23-.55-.21-.87a.69.69,0,0,1,.81-.6.3.3,0,0,0,.16-.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    className: "cls-7",
    d: "M50.51,57.29a21.931,21.931,0,0,0-2.28.2c-.5.09-.39.95.12.89a21.42,21.42,0,0,0,2.25-.48.31.31,0,0,0-.09-.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    className: "cls-7",
    d: "M49.44,57c-.85-.2-2.1.26-2.14,1.27a.21.21,0,0,0,.38.1c.46-.61.86-1.13,1.72-1a.16.16,0,0,0,0-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    className: "cls-7",
    d: "M70.52,32.59c-1.81,1.88-3.82,4.4-4.26,7a.36.36,0,0,0,.66.28c.71-1.13,1.16-2.46,1.79-3.64s1.33-2.37,2.08-3.49c.1-.16-.14-.34-.27-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2097",
    "data-name": "Group 2097",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    className: "cls-7",
    d: "M71.41,31.35A62.379,62.379,0,0,0,61,45c-.13.22.2.51.37.29,3.5-4.49,6.82-9.12,10.35-13.59.17-.21-.1-.5-.3-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2098",
    "data-name": "Group 2098",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    className: "cls-7",
    d: "M35.85,75c2.22-1.47,3.95-3.91,5.75-5.86A59.24,59.24,0,0,0,47.08,63c.28-.4-.3-.75-.62-.48a60.6,60.6,0,0,0-5.92,6.27c-1.7,1.85-3.84,3.67-5,5.89-.12.21.13.5.35.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    className: "cls-7",
    d: "M35.76,74.16c4.15-3.27,7.62-7.84,11.22-11.69.44-.47-.26-1.18-.7-.7-3.63,3.87-8,7.63-11,12-.22.31.23.57.48.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2100",
    "data-name": "Group 2100",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    className: "cls-7",
    d: "M35.61,74.43c2.16-1.36,3.93-3.53,5.69-5.36,2-2.06,4-4.14,5.8-6.37.35-.43-.22-1-.62-.62-2,2.07-3.85,4.26-5.84,6.33-1.77,1.84-3.93,3.56-5.37,5.68C35.12,74.29,35.4,74.56,35.61,74.43Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/TIME.dd25f0df5c30f6c6b1b33c52f72a871d.svg";
export { ForwardRef as ReactComponent };